//#region Imports
import React, { useEffect, useMemo, useRef, useState } from "react";
import { clampIsoDateToToday, getReportDateInputProps } from "../../utils/reportDateLimits";
//MUI
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Box,
  Button,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import XLSX, { boldDomTheadRows } from "utils/xlsxStyled";
import eOpsLogo from "../../images/eops.png";
import "../../style/common.scss";
import ReportExportButtons from "./components/ReportExportButtons";
import "./reportPageLayout.scss";
import "./ChangeOfAttributesStatusReport.scss";
import "./DueDateExtensionReports.scss";
import {
  renderBillOrDueDateCategoryValue,
  renderCircleValue,
  renderDivisionValue,
  renderSubDivisionValue,
} from "./coaHierarchySelectRenderers";
import { cfpBaseUrl } from "../../network/urls";
import {
  convertDate,
  convertDatewithTime,
  printStamp,
  subdivisionName,
  getName,
} from "../../services/Functions";
import FESCOLOGO from "../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../images/pitc.png";
//#endregion

const DueDateExtensionReports = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are 0-indexed
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId } =
    useSelector((state) => state.auth);
  const companyCode = code.slice(0, 2);
  const offCode = code;
  const [isLoading, setIsLoading] = React.useState(false);
  // const { officeCode: offCode } = useSelector(state => state.officeCode)
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");
  const [totals, setTotals] = useState({});
  // const [officeCode, setOfficeCode] = useState('');
  const [dateFrom, setDateFrom] = useState(getCurrentDate());
  const [dateTo, setDateTo] = useState(getCurrentDate());
  const tableRef = useRef(null);
  const [dateFromDisplay, setDateFromDisplay] = useState("");
  const [dateToDisplay, setDateToDisplay] = useState("");
  const [category, setCategory] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [circleCode, setCircleCode] = useState("");
  const [circleName, setCircleName] = useState("");
  const [officeCode, setOfficeCode] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [hierarchy, setHierarchy] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [selectedPerson, setSelectedPerson] = useState("");
  const [lastModifiedByOptions, setLastModifiedByOptions] = useState([]);
  const [selectedPerson1, setSelectedPerson1] = useState("");
  const [registeredByOptions, setRegisteredByOptions] = useState([]);
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));

  const getProcessedByOptionLabel = (item) => {
    const processedBy = item?.processedBy || "-";
    const lastModifiedBy = item?.lastModifiedBy || "-";
    return `${processedBy} (${lastModifiedBy})`;
  };
  useEffect(() => {
    setOfficeCode(circleCode);
  }, [circleCode]);

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              console.error("Error fetching subDivisions:", result.message);
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching subDivisions:", error);
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(offCode == 10 ? 15 : offCode);
          let officeName = getName(
            offCode == 10 ? "15" : offCode.toString(),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(offCode == 10 ? 15 : offCode);
        let offName = getName(
          offCode == 10 ? "15" : offCode.toString(),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            setOfficeCode(15);
            setOfficeName("PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        console.log("1 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        console.log("2 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        console.log("3 wala if");
        setCircleCode(offCode.slice(0, 3));
        console.log(offCode.slice(0, 3), "djlsahjdhalhdalhlkd");
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        console.log("4 wala if");
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  const exportToExcel = () => {
    const wb = XLSX.utils.table_to_book(tableRef.current, { sheet: "Sheet1" });
    boldDomTheadRows(wb.Sheets[wb.SheetNames[0]], tableRef.current, 0);
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const filename = `${officeName}- From ${dateFrom} - to ${dateTo} - Due-Date-Extension-Report.xlsx`;
    saveAs(new Blob([wbout]), filename);
  };
  const connectionTypes = [
    "Sr. No.",
    "Tracking Id.",
    "Reference No.",
    "Due Date",
    "No. Of Days Extended",
    "Extended Date",
    "Amount",
    "Registered",
    "Source",
    "Processed",
  ];

  const [categoryName, setcategoryName] = useState("");

  const getStats = async (officeCode, dateFrom, dateTo, status) => {
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const formdata = new FormData();
      formdata.append("officeCode", officeCode);
      formdata.append("dateFrom", dateFrom ? dateFrom : "");
      formdata.append("dateTo", dateTo ? dateTo : "");
      formdata.append("applicationProgressId", status === "" || status === null || status === undefined
        ? ""
        : String(status));

      const requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "comman/getDueDateStats", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            const data = result.data;
            const lastModifiedByList = [
              ...new Map(
                data
                  .filter((item) => item.processedBy)
                  .map((item) => [item.processedBy, getProcessedByOptionLabel(item)]),
              ).entries(),
            ].map(([value, label]) => ({ value, label }));
            const registeredByList = [
              ...new Set(data.map((item) => item.registeredBy).filter(Boolean)),
            ];
            setDateFromDisplay(result.dateFrom);
            setDateToDisplay(result.dateTo);
            setLastModifiedByOptions(lastModifiedByList);
            setRegisteredByOptions(registeredByList);

            setTableData(data);
          } else if (result.status === "400") {
            setTableData([]);
            setLastModifiedByOptions([]);
            setRegisteredByOptions([]);
          }
        })
        .catch((error) => console.error(error));
    } catch (e) {
      console.log(e);
    }
    setViewBackdrop(false);
  };

  // const DownloadPdf = async (print) => {
  //     return new Promise((resolve, reject) => {
  //         let offName = subdivisionName(parseInt(code), subDivisions);
  //         let dateToPrint = convertDate(new Date());
  //         let stampData = printStamp(code, offName, name, roleName, dateToPrint);

  //         const title = dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo) ?
  //             `Daily Due Date Extension Report  - ${category === '' ? 'All' : categoryName}` :
  //             `${dateFrom ? convertDate(dateFrom) : '-'} to ${dateTo ? convertDate(dateTo) : '-'} - ${category === '0' ? 'All' : categoryName}`

  //         const pdf = new jsPDF('landscape', 'mm', 'a4');
  //         const pageWidth = pdf.internal.pageSize.getWidth();
  //         const pageHeight = pdf.internal.pageSize.getHeight();

  //         // Add logos and titles
  //         pdf.addImage(mepcoLogo, 'PNG', 15, 5, 30, 10); // Mepco logo
  //         pdf.addImage(eOpsLogo, 'PNG', 17, 17, 20, 8); // eOps logo
  //         pdf.setFontSize(12);
  //         pdf.text('Multan Electric Power Company', pageWidth / 2, 12, { align: 'center' });
  //         pdf.text(`Due Date Extension Report for ${officeName || '(MEPCO Region)'}`, pageWidth / 2, 18, { align: 'center' });
  //         pdf.setFontSize(10);
  //         pdf.text(title, pageWidth / 2, 25, { align: 'center' });
  //         pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
  //         pdf.text("Name: " + name, pageWidth - 65, 17);
  //         pdf.text("Designation: " + roleName, pageWidth - 65, 22);

  //         // Build headers
  //         const headers = [
  //             { content: "S.No", styles: { halign: 'left' } },
  //             { content: "Application ID", styles: { halign: 'left' } },
  //             { content: "Ref No", styles: { halign: 'left' } },
  //             { content: "Customer ID", styles: { halign: 'left' } },
  //             { content: "RO. Office", styles: { halign: 'left' } },
  //             { content: "No. Of Days Extended", styles: { halign: 'left' } },
  //             { content: "Extended Date", styles: { halign: 'left' } },
  //             { content: "Amount", styles: { halign: 'left' } },
  //             { content: "Registered", styles: { halign: 'left' } },
  //             { content: "Source", styles: { halign: 'left' } },
  //             { content: "Processed", styles: { halign: 'left' } },

  //         ];

  //         // Map tableData into bodyData

  //         let bodyData = [];
  //         const filteredData = tableData.filter(item => {
  //             const matchProcessedBy = selectedPerson === "" || item.processedBy === selectedPerson;
  //             const matchRegisteredBy = selectedPerson1 === "" || item.registeredBy === selectedPerson1;
  //             return matchProcessedBy || matchRegisteredBy;
  //         });

  //         if (filteredData && filteredData.length > 0) {
  //             bodyData = filteredData.map((item, id) => [
  //                 { content: id + 1 || '-', styles: { halign: 'left' } },
  //                 { content: item.applicationId || '-', styles: { halign: 'left' } },
  //                 { content: item.refNo || '-', styles: { halign: 'left' } },
  //                 { content: item.customerId || '-', styles: { halign: 'left' } },
  //                 { content: item.divisionCode || '-', styles: { halign: 'left' } },
  //                 { content: getDateDifference(item.dueDate, item.appliedExtentionOfDueDate) || '-', styles: { halign: 'left' } },
  //                 { content: item.approvedExtendedDueDate || '-', styles: { halign: 'left' } },
  //                 { content: item.currentBillAmount || '-', styles: { halign: 'left' } },
  //                 { content: `${item.registeredBy || '-'}\n${formatDate(item.creationDate) || '-'}\n${item.createdBy || '-'}` || '-', styles: { halign: 'left' } },
  //                 { content: item.submittedThrough || '-', styles: { halign: 'left' } },
  //                 { content: `${item.processedBy || '-'}\n${formatDate(item.lastModificationDate) || '-'}\n${item.lastModifiedBy || '-'}`, styles: { halign: 'left' } }
  //             ]);
  //         } else {
  //             bodyData.push([{
  //                 content: 'No Data Found',
  //                 colSpan: headers.length,
  //                 styles: {
  //                     halign: 'center',
  //                     fontSize: 12,
  //                     fontStyle: 'bold',
  //                     fillColor: [255, 255, 255],
  //                     textColor: [255, 0, 0]
  //                 }
  //             }]);
  //         }

  //         // Generate table
  //         pdf.autoTable({
  //             startY: 28,
  //             head: [headers],
  //             body: bodyData,
  //             styles: { cellPadding: 3, fontSize: 8, halign: 'center' },
  //             theme: 'striped',
  //             columnStyles: { 0: { cellWidth: 10 } } // Adjust column widths as needed
  //         });

  //         // Add page numbers
  //         const totalPages = pdf.internal.getNumberOfPages();
  //         for (let i = 1; i <= totalPages; i++) {
  //             pdf.setPage(i);
  //             const pageNumberText = `Page ${i} of ${totalPages}`;
  //             pdf.setFontSize(10);
  //             pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
  //         }

  //         // Save or resolve PDF
  //         if (print) {
  //             pdf.save(`${officeName || 'MEPCO Region'} - From ${dateFrom} - to ${dateTo} - Due-Date-Extension-Report.xlsx`);
  //             resolve(pdf);
  //         } else {
  //             resolve(pdf);
  //         }
  //     });
  // };

  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };

  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };

  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = subdivisionName(parseInt(code), subDivisions);
      let dateToPrint = convertDate(new Date());
      let stampData = printStamp(code, offName, name, roleName, dateToPrint);

      const title =
        dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
          ? `Daily Due Date Extension Report  - ${
              category === "" ? "All" : categoryName
            }`
          : `${dateFrom ? convertDate(dateFrom) : "-"} to ${
              dateTo ? convertDate(dateTo) : "-"
            } - ${category === "" ? "All" : categoryName}`;

      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          (companyCode === "59") | (companyCode === "27")
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );
      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(
        `Due Date Extension Report for ${officeName}`,
        pageWidth / 2,
        18,
        { align: "center" }
      );
      pdf.setFontSize(10);
      pdf.text(title, pageWidth / 2, 25, { align: "center" });
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      const headers = [
        { content: "S.No", styles: { halign: "left" } },
        { content: "Application ID", styles: { halign: "left" } },
        { content: "Ref No", styles: { halign: "left" } },
        { content: "Due Date", styles: { halign: "left" } },
        { content: "No. Of Days Extended", styles: { halign: "left" } },
        { content: "Extended Date", styles: { halign: "left" } },
        { content: "Amount", styles: { halign: "left" } },
        { content: "Registered", styles: { halign: "left" } },
        { content: "Source", styles: { halign: "left" } },
        { content: "Processed", styles: { halign: "left" } },
      ];

      const filteredData = tableData.filter((item) => {
        const matchProcessedBy =
          selectedPerson === "" || item.processedBy === selectedPerson;
        const matchRegisteredBy =
          selectedPerson1 === "" || item.registeredBy === selectedPerson1;
        return matchProcessedBy && matchRegisteredBy;
      });

      let bodyData = [];

      if (filteredData && filteredData.length > 0) {
        bodyData = filteredData.map((item, id) => [
          { content: id + 1 || "-", styles: { halign: "left" } },
          { content: item.applicationId || "-", styles: { halign: "left" } },
          { content: item.refNo || "-", styles: { halign: "left" } },
          {
            content: formatDate(item.dueDate) || "-",
            styles: { halign: "left" },
          },
          {
            content:
              getDateDifference(item.dueDate, item.appliedExtentionOfDueDate) ||
              "-",
            styles: { halign: "left" },
          },
          {
            content: item.approvedExtendedDueDate || "-",
            styles: { halign: "left" },
          },
          {
            content: item.currentBillAmount || "-",
            styles: { halign: "left" },
          },
          {
            content:
              `${item.registeredBy || "-"}\n${
                formatDate(item.creationDate) || "-"
              }\n${item.createdBy || "-"}` || "-",
            styles: { halign: "left" },
          },
          { content: item.submittedThrough || "-", styles: { halign: "left" } },
          {
            content: `${item.processedBy || "-"}\n${
              formatDate(item.lastModificationDate) || "-"
            }\n${item.lastModifiedBy || "-"}`,
            styles: { halign: "left" },
          },
        ]);
      } else {
        bodyData.push([
          {
            content: "No Data Found",
            colSpan: headers.length,
            styles: {
              halign: "center",
              fontSize: 12,
              fontStyle: "bold",
              fillColor: [255, 255, 255],
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      pdf.autoTable({
        startY: 28,
        head: [headers],
        body: bodyData,
        styles: {
          cellPadding: 2,
          fontSize: 7,
          halign: "left",
          overflow: "linebreak",
        },
        theme: "striped",
        margin: { left: 15, right: 15 },
        headStyles: {
          fillColor: [0, 106, 209],
          textColor: [255, 255, 255],
          fontStyle: "bold",
          fontSize: 7,
          halign: "center",
          valign: "middle",
        },
        columnStyles: { 0: { cellWidth: 10 } },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      if (print) {
        pdf.save(
          `${officeName} - From ${dateFrom} - to ${dateTo} - Due-Date-Extension-Report.pdf`
        );
        resolve(pdf);
      } else {
        resolve(pdf);
      }
    });
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");

    // Create an iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };

  const getDateDifference = (startDate, endDate) => {
    // Convert the date strings to Date objects
    const startDates = startDate.split(",")[0];
    const endDates = endDate.split(",")[0];

    const start = new Date(startDates);
    const end = new Date(endDates);

    // Calculate the difference in time (milliseconds)
    const differenceInTime = end - start;

    // Convert time difference from milliseconds to days
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    return differenceInDays;
  };

  const handleProcessedChange = (e) => {
    setSelectedPerson(e.target.value);
  };
  const handleRegisteredChange = (e) => {
    setSelectedPerson1(e.target.value);
  };

  const handleCategoryChange = (e) => {
    const raw = e.target.value;
    if (raw === "") {
      setCategory("");
      setcategoryName("");
      return;
    }
    const v = Number(raw);
    setCategory(v);
    const labels = { [-1]: "Rejected", 0: "Pending", 1: "Approved" };
    setcategoryName(labels[v] || "");
  };

  const filteredTableRows = useMemo(() => {
    return tableData.filter((item) => {
      const matchProcessedBy =
        selectedPerson === "" || item.processedBy === selectedPerson;
      const matchRegisteredBy =
        selectedPerson1 === "" || item.registeredBy === selectedPerson1;
      return matchProcessedBy && matchRegisteredBy;
    });
  }, [tableData, selectedPerson, selectedPerson1]);

  const currentFilters = {
    officeCode,
    dateFrom,
    dateTo,
    category,
    ...(code == 10
      ? {
          selectedCompanyCode,
          circleCode,
          selectedDivision,
          selectedSubDivision,
        }
      : { circleCode, selectedDivision, selectedSubDivision }),
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [
    lastAppliedFilters,
    officeCode,
    dateFrom,
    dateTo,
    category,
    code,
    selectedCompanyCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
  ]);

  const handleGoClick = () => {
    getStats(officeCode, dateFrom, dateTo, category);

    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
  };

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  const FilterFieldLabel = ({ htmlFor, children }) => (
    <Typography
      component="label"
      variant="body2"
      htmlFor={htmlFor}
      sx={{
        fontWeight: 600,
        color: "text.secondary",
        display: "block",
        mb: 0.5,
        lineHeight: 1.35,
      }}
    >
      {children}
    </Typography>
  );

  const tableCaptionText =
    dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
      ? `Daily Due Date Extension Report for (${officeName}) - ${
          category === "" ? "All" : categoryName
        }`
      : `Due Date Extension Report for (${officeName}) from ${
          dateFrom ? convertDate(dateFrom) : "-"
        } to ${dateTo ? convertDate(dateTo) : "-"} - ${
          category === "" ? "All" : categoryName
        }`;

  const renderFilters = ({ showGo = false } = {}) => (
    <Grid
      container
      spacing={2}
      alignItems="flex-start"
      className="coa-filters-grid-wrap"
    >
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="dde-date-from">Date From</FilterFieldLabel>
          <TextField
            id="dde-date-from"
            fullWidth
            size="small"
            variant="outlined"
            type="date"
            value={dateFrom}
            inputProps={getReportDateInputProps()}
            onChange={(e) => setDateFrom(clampIsoDateToToday(e.target.value))}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="dde-date-to">Date To</FilterFieldLabel>
          <TextField
            id="dde-date-to"
            fullWidth
            size="small"
            variant="outlined"
            type="date"
            value={dateTo}
            inputProps={getReportDateInputProps()}
            onChange={(e) => setDateTo(clampIsoDateToToday(e.target.value))}
          />
        </Stack>
      </Grid>
      {code == 10 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="dde-company">Company</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="dde-company"
                displayEmpty
                value={selectedCompanyCode || ""}
                onChange={handleChangeCompany}
              >
                <MenuItem value="">
                  <em>Select Company</em>
                </MenuItem>
                <MenuItem value="11">LESCO</MenuItem>
                <MenuItem value="12">GEPCO</MenuItem>
                <MenuItem value="13">FESCO</MenuItem>
                <MenuItem value="14">IESCO</MenuItem>
                <MenuItem value="15">MEPCO</MenuItem>
                <MenuItem value="26">PESCO</MenuItem>
                <MenuItem value="27">HAZECO</MenuItem>
                <MenuItem value="37">HESCO</MenuItem>
                <MenuItem value="38">SEPCO</MenuItem>
                <MenuItem value="48">QESCO</MenuItem>
                <MenuItem value="59">TESCO</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 2 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="dde-circle">Circle</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="dde-circle"
                displayEmpty
                value={
                  circleCode === "" || circleCode === undefined || circleCode === null
                    ? ""
                    : circleCode
                }
                onChange={handleCircleChange}
                renderValue={(v) => renderCircleValue(v, filteredCircles)}
              >
                <MenuItem value="">
                  <em>All Circle</em>
                </MenuItem>
                {filteredCircles.map((circle) => (
                  <MenuItem key={circle.circleCode} value={circle.circleCode}>
                    {circle.circleName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 3 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="dde-division">Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="dde-division"
                displayEmpty
                value={
                  selectedDivision === "" ||
                  selectedDivision === undefined ||
                  selectedDivision === null
                    ? ""
                    : selectedDivision
                }
                onChange={handleDivisionChange}
                disabled={!circleCode}
                renderValue={(v) => renderDivisionValue(v, filteredDivisions)}
              >
                <MenuItem value="">
                  <em>All Division</em>
                </MenuItem>
                {filteredDivisions.map((division) => (
                  <MenuItem key={division.divisionCode} value={division.divisionCode}>
                    {division.divisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 4 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="dde-subdiv">Sub-Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="dde-subdiv"
                displayEmpty
                value={
                  selectedSubDivision === "" ||
                  selectedSubDivision === undefined ||
                  selectedSubDivision === null
                    ? ""
                    : selectedSubDivision
                }
                onChange={handleSubDivisionChange}
                disabled={!selectedDivision}
                renderValue={(v) =>
                  renderSubDivisionValue(v, filteredSubDivisions)
                }
              >
                <MenuItem value="">
                  <em>All Sub-Division</em>
                </MenuItem>
                {filteredSubDivisions.map((subDivision) => (
                  <MenuItem
                    key={subDivision.subDivisionCode}
                    value={subDivision.subDivisionCode}
                  >
                    {subDivision.subDivisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="dde-category">Category</FilterFieldLabel>
          <FormControl fullWidth size="small" variant="outlined">
            <Select
              id="dde-category"
              displayEmpty
              value={category === "" ? "" : category}
              onChange={handleCategoryChange}
              renderValue={(v) => renderBillOrDueDateCategoryValue(v)}
            >
              <MenuItem value="">
                <em>All</em>
              </MenuItem>
              <MenuItem value={-1}>Rejected</MenuItem>
              <MenuItem value={0}>Pending</MenuItem>
              <MenuItem value={1}>Approved</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Grid>
      {showGo && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5} sx={{ pt: "2px" }}>
            <Box
              aria-hidden
              sx={{
                height: "1.35rem",
                mb: 0.5,
                lineHeight: 1.35,
              }}
            />
            <Button
              id="dde-go-btn"
              fullWidth
              variant="contained"
              disableElevation
              className="coa-go-btn"
              onClick={handleGoClick}
              disabled={isGoDisabled || viewBackdrop}
            >
              GO
            </Button>
          </Stack>
        </Grid>
      )}
      {registeredByOptions?.length > 0 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="dde-reg-by">Registered by</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="dde-reg-by"
                displayEmpty
                value={selectedPerson1}
                onChange={handleRegisteredChange}
              >
                <MenuItem value="">
                  <em>Select a person</em>
                </MenuItem>
                {registeredByOptions.map((person, index) => (
                  <MenuItem key={index} value={person}>
                    {person}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {lastModifiedByOptions?.length > 0 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="dde-proc-by">Processed by</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="dde-proc-by"
                displayEmpty
                value={selectedPerson}
                onChange={handleProcessedChange}
              >
                <MenuItem value="">
                  <em>Select a person</em>
                </MenuItem>
                {lastModifiedByOptions.map((person, index) => (
                  <MenuItem key={index} value={person.value}>
                    {person.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
    </Grid>
  );

  return (
    <>
      <Box className="form-box rpt-page coa-status-report dde-extension-page">
        <div className="coa-layout">
          <header className="coa-page-header">
            <h1 className="coa-page-title">Due Date Extension Report</h1>
          </header>

          <div className="coa-toolbar-stack">
            <Paper
              variant="outlined"
              className="coa-card coa-card--filters"
              sx={{
                p: 2,
                width: "100%",
                bgcolor: "#fff",
                borderRadius: 2,
                borderColor: "divider",
              }}
            >
              <div
                className={
                  isMdUp ? "coa-filters coa-filters--mui-grid" : "coa-filters"
                }
              >
                {isMdUp ? (
                  renderFilters({ showGo: true })
                ) : (
                  <p className="coa-filters-hint">
                    Tap <strong>Filters</strong> to set dates and options, then
                    tap <strong>GO</strong>.
                  </p>
                )}
              </div>

              <Stack
                direction="row"
                flexWrap="wrap"
                alignItems="center"
                justifyContent={{ xs: "flex-start", md: "flex-end" }}
                spacing={1}
                className="coa-export-strip"
                sx={{
                  pt: 2,
                  mt: 2,
                  borderTop: "1px solid",
                  borderColor: "divider",
                  gap: 1,
                }}
              >
                {!isMdUp && (
                  <Tooltip title="Filters">
                    <IconButton
                      color="primary"
                      onClick={() => setMobileFilterOpen(true)}
                      aria-label="Open filters"
                      size="small"
                    >
                      <FilterListIcon />
                    </IconButton>
                  </Tooltip>
                )}
                {!isMdUp && (
                  <Button
                    variant="contained"
                    disableElevation
                    className="coa-go-btn"
                    size="small"
                    onClick={handleGoClick}
                    disabled={isGoDisabled || viewBackdrop}
                  >
                    GO
                  </Button>
                )}
                <ReportExportButtons
                  isEmpty={tableData.length === 0}
                  onEmpty={noDataAvailable}
                  onPdf={() => DownloadPdf(true)}
                  onExcel={exportToExcel}
                  onPrint={printPDF}
                />
              </Stack>
            </Paper>
          </div>

          <div className="coa-report-banner" role="status">
            {tableCaptionText}
          </div>

          {isPhone && (
            <div className="coa-mobile-stack">
              {filteredTableRows.length === 0 ? (
                <div className="coa-mobile-empty" role="status">
                  No data for this run. Open <strong>Filters</strong>, tap{" "}
                  <strong>GO</strong>.
                </div>
              ) : (
                filteredTableRows.map((item, id) => (
                  <article
                    key={
                      "d-" +
                      (item.applicationId || item.refNo || "") +
                      "-" +
                      id
                    }
                    className="coa-mcard"
                  >
                    <div className="coa-mcard__top">
                      <div className="coa-mcard__ids">
                        <span className="coa-mcard__sr">#{id + 1}</span>
                        <span className="coa-mcard__aid">
                          {item.applicationId || "—"}
                        </span>
                      </div>
                    </div>
                    <dl className="coa-mcard__dl">
                      <div>
                        <dt>Reference No.</dt>
                        <dd>{item.refNo || "—"}</dd>
                      </div>
                      <div>
                        <dt>Due Date</dt>
                        <dd>{formatDate(item.dueDate) || "—"}</dd>
                      </div>
                      <div>
                        <dt>No. Of Days Extended</dt>
                        <dd>
                          {getDateDifference(
                            item.dueDate,
                            item.appliedExtentionOfDueDate
                          )}
                        </dd>
                      </div>
                      <div>
                        <dt>Extended Date</dt>
                        <dd>{item.approvedExtendedDueDate || "—"}</dd>
                      </div>
                      <div>
                        <dt>Amount</dt>
                        <dd>{item.currentBillAmount ?? "—"}</dd>
                      </div>
                      <div>
                        <dt>Registered</dt>
                        <dd>
                          {[
                            item.registeredBy,
                            formatDate(item.creationDate),
                            item.createdBy,
                          ]
                            .filter(Boolean)
                            .join(" · ") || "—"}
                        </dd>
                      </div>
                      <div>
                        <dt>Source</dt>
                        <dd>{item.submittedThrough || "—"}</dd>
                      </div>
                      <div>
                        <dt>Processed</dt>
                        <dd>
                          {[
                            item.processedBy,
                            formatDate(item.lastModificationDate),
                            item.lastModifiedBy,
                          ]
                            .filter(Boolean)
                            .join(" · ") || "—"}
                        </dd>
                      </div>
                    </dl>
                  </article>
                ))
              )}
            </div>
          )}

          <Box
            className="application-table"
            sx={{ width: "100%", maxWidth: "100%", minWidth: 0 }}
          >
            <div className="div-datagrid">
              <div
                className={
                  "coa-table-panel" +
                  (isPhone ? " coa-table-panel--hide-phone" : "")
                }
              >
                <div className="coa-table-scroll" id="pdf-table">
                  <table className="coa-data-table table" ref={tableRef}>
                    <thead>
                      <tr>
                        {connectionTypes.map((type, index) => (
                          <th key={index} scope="col">
                            {type}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredTableRows.length > 0 ? (
                        filteredTableRows.map((item, id) => (
                          <tr key={item.applicationId || id}>
                            <td>{id + 1}</td>
                            <td>{item.applicationId || "-"}</td>
                            <td>{item.refNo || "-"}</td>
                            <td>{formatDate(item.dueDate) || "-"}</td>
                            <td>
                              {getDateDifference(
                                item.dueDate,
                                item.appliedExtentionOfDueDate
                              )}
                            </td>
                            <td>{item.approvedExtendedDueDate || "-"}</td>
                            <td>{item.currentBillAmount || "-"}</td>
                            <td>
                              {item.registeredBy || "-"}
                              <br />
                              {formatDate(item.creationDate) || "-"}
                              <br />
                              {item.createdBy || "-"}
                            </td>
                            <td>{item.submittedThrough || "-"}</td>
                            <td>
                              {item.processedBy || "-"}
                              <br />
                              {formatDate(item.lastModificationDate) || "-"}
                              <br />
                              {item.lastModifiedBy || "-"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className="coa-empty-row">
                          <td colSpan={connectionTypes.length}>
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Box>

          <Drawer
            anchor="left"
            open={mobileFilterOpen}
            onClose={() => setMobileFilterOpen(false)}
            PaperProps={{
              className: "coa-filter-drawer",
              sx: {
                width: { xs: "100%", sm: 400 },
                maxWidth: "100vw",
                boxSizing: "border-box",
              },
            }}
          >
            <Box
              className="coa-drawer-inner"
              sx={{ p: 2, pb: 3, boxSizing: "border-box" }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 2 }}
              >
                <Typography variant="h6" component="div">
                  Filters
                </Typography>
                <IconButton
                  aria-label="Close filters"
                  onClick={() => setMobileFilterOpen(false)}
                  edge="end"
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
              {renderFilters({ showGo: true })}
            </Box>
          </Drawer>
        </div>
      </Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (muiTheme) => muiTheme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default DueDateExtensionReports;
